<template>
  <div class="system-message-container">
    <div class="ui-block">
      <!-- Post -->
      <article class="hentry post welcome-container">
        <div class="post__author author vcard inline-items">
          <img
            src="/img/favicon2.png"
            alt="author"
            class="fit-contain"
          />
        </div>
        <span v-if="message.message === 'WELCOME' && message.title === 'WELCOME'">
          <div class="text-break welcome-message-container modal-black">
            <h1 class="modal-black bold">Welcome to <span class="modal-green">Swampum</span></h1>
            <h3 class="modal-black bold">We’re glad you’ve joined us!</h3>
            <div class="first-message">
              <p>To get started, try
                <span
                  @click="openItemModal"
                  class="font-weight-bold modal-green"
                >posting something&nbsp;</span>
                you want to give away.
              </p>
              <p>
                Or
                <span @click="openGroupModal" class="font-weight-bold modal-purple">create a new group&nbsp;</span>
                for people you’re close to.
              </p>
            </div>
            <p>
              For more information on how Swampum works, check out the
              <router-link to="/landing-help" class="font-weight-bold modal-green">FAQs</router-link>.
            </p>
          </div>
        </span>
        <p v-else>{{message.message}}</p>
      </article>

      <!-- .. end Post -->
      <!-- .. end Post -->
      <!---->
    </div>
  </div>
</template>
<script>
import moment from "moment";
import UserHelper from "../../mixins/UserHelper.vue";

export default {
  name: "SNewSystemMessage",
  props: ["message"],
  mixins: [UserHelper],
  data() {
    return {
      msg: "",
    };
  },
  methods: {
    getTimeAgo(time) {
      return moment(time).fromNow();
    },
    openItemModal() {
      $("#new-item").modal("show");
    },
    openGroupModal() {
      $("#create-group").modal("show");
    },
  },
  computed: {
    timeCreatedAccount() {
      const user = this.loggedUser || {};
      return user.createdAt || this.message.createdAt;
    }
  }
};
</script>
<style scoped>
.system-message-container {
  width: 100%;
}

h1 {
  font-size: 3rem;
  letter-spacing: 1px;
}

h3 {
  font-size: 2rem;
  font-weight: 500;
  letter-spacing: 1px;
}

.welcome-container, .welcome-message-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.welcome-container img {
  width: 110px;
  border-radius: unset;
}

.welcome-message-container p {
  margin-top: 10px;
  font-size: 18px;
  letter-spacing: 2px;
}

.first-message {
  margin-top: 40px;
}

.modal-purple {
  cursor: pointer;
  color: purple;
}

.modal-black {
  color: black;
}
.modal-green {
  cursor: pointer;
  color: #05919b;
}


</style>